// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../../Commons/properties/Resources.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let BaseFibonacciDataCacheTool = function ()
{
    this.fibLevel = null;
    this.levelsVisibility = null;
    this.fibLevelText = null;

    DataCacheTool.apply(this);
};

BaseFibonacciDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

//#region ICaller

BaseFibonacciDataCacheTool.prototype.Properties = function ()
{
    var properties = DataCacheTool.prototype.Properties.apply(this);

    var fibLevel = this.fibLevel;
    if (!fibLevel) return properties;

    // чтоб в группе свойств фибоначчи всегда было свойство
    properties.push(new DynProperty("IsFibbonacci", true, DynProperty.BOOLEAN, /*DynProperty.FIBONACCI_PARAMETERS_GROUP*/DynProperty.HIDDEN_GROUP));

    var levelsVisibility = this.levelsVisibility;
    //+++denis добавлено видимость
    if (levelsVisibility && levelsVisibility.length === fibLevel.length)
    {
        for (var i = 0; i < fibLevel.length; i++)
        {
            var p = new DynProperty("Level" + i, [fibLevel[i], levelsVisibility[i]], DynProperty.FIBLEVEL, /*DynProperty.FIBONACCI_PARAMETERS_GROUP*/DynProperty.HIDDEN_GROUP);
            p.propertyComment = Resources.getResource("property.Level") + i;
            p.increment = 0.01;
            p.decimalPlaces = 2;
            p.sortIndex = i * 10;
            properties.push(p);
        }
    }
        // иначе все как и было
    else
    {
        for (var i = 0; i < fibLevel.length; i++)
        {
            var p = new DynProperty("Level" + i, fibLevel[i], DynProperty.DOUBLE, /*DynProperty.FIBONACCI_PARAMETERS_GROUP*/DynProperty.HIDDEN_GROUP);
            p.propertyComment = Resources.getResource("property.Level") + i;
            p.increment = 0.01;
            p.decimalPlaces = 2;
            p.sortIndex = i * 10;
            properties.push(p);
        }
    }

    return properties;
};

BaseFibonacciDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var fibonacci = [];

    var properties_len = properties.length;
    for (var i = 0; i < properties_len; i++)
    {
        var prop = properties[i];
        if (prop.group == DynProperty.FIBONACCI_PARAMETERS_GROUP &&
            prop.name !== "IsFibbonacci" &&
            prop.name !== "EnableNegativeFibonacciValue")
            fibonacci.push(prop);
    };
    // если тулза фибоначчи и даже если у нее удалили все уровни..
    if (fibonacci.length > 0 || DynProperty.getPropertyByName(properties, "IsFibbonacci"))
    {
        var fibLevel = new Array(fibonacci.length);
        var levelsVisibility = new Array(fibonacci.length);

        var fibonacci_len = fibonacci.length;
        for (var i = 0; i < fibonacci_len; i++)
        {
            var value = fibonacci[i].value;
            if (value === null) continue;

            if (Array.isArray(value))
            {
                fibLevel[i] = value[0];
                levelsVisibility[i] = value[1];
            }
            else if (typeof value === 'number')
            {
                fibLevel[i] = value;
                levelsVisibility = null;
            }
        }
        if (!fibLevel.length)
            this.fibLevel = this.fibLevel;
        else
            this.fibLevel = fibLevel;
        this.levelsVisibility = levelsVisibility;
    }
};

//#endregion